module.exports = __webpack_public_path__ + "static/folding_boat-2c345c9ac31350283588a5b38286467c.jpeg";